import { FC, ReactNode } from 'react';

interface Props {
  id?: string;
  title?: string;
  description?: string;
  children: ReactNode;
  buttonSection?: ReactNode; // Define the prop for the button section
}

export const ClientOrderScreen: FC<Props> = ({ children, description, id, title, buttonSection }) => {
  return (
    <div className="flex flex-1  overflow-x-auto overflow-y-hidden ">
      <div className="flex flex-1 flex-col ">
        <div className="flex space-x-[0.5rem]">
          {id && <div className="text-red text-xl font-semibold ">{id}</div>}
          <div className="flex flex-col space-y-[0.5rem]">
            {title && <div className="text-xl">{title}</div>}
            {description && (
              <div className="text-sm text-secondary_text font-medium sm:hidden md:block ">{description}</div>
            )}
          </div>
        </div>
        <div className="flex-grow">{children}</div>
        {buttonSection}
      </div>
    </div>
  );
};
